import { MutationHookOptions, useMutation } from '@apollo/client'
import {
  BulkCreatePolicyAssignmentsDocument,
  BulkCreatePolicyAssignmentsMutation,
  BulkCreatePolicyAssignmentsMutationVariables,
  GetCurrentPolicyAssignmentsDocument,
  TimeoffPolicyEmployeesCollectionListDocument,
} from 'generated/resources/graphql'

type Options = MutationHookOptions<
  BulkCreatePolicyAssignmentsMutation,
  BulkCreatePolicyAssignmentsMutationVariables
>

export type Variables = BulkCreatePolicyAssignmentsMutationVariables

export const useBulkCreatePolicyAssignments = (options?: Options) => {
  const [bulkCreatePolicyAssignments, { loading }] = useMutation(
    BulkCreatePolicyAssignmentsDocument,
    options
  )

  return {
    loading,
    create(variables: BulkCreatePolicyAssignmentsMutationVariables) {
      return bulkCreatePolicyAssignments({
        variables,
        errorPolicy: 'all',
        refetchQueries: [
          GetCurrentPolicyAssignmentsDocument,
          TimeoffPolicyEmployeesCollectionListDocument,
        ],
      })
    },
  }
}
